import { computed } from '@ember/object';
import BaseActualFilterAmplitude from '../../implementation-common/base-actual-filter-amplitude';
import * as Complex from '../../../process-data/complex';
import * as CommonUtils from '../../../../utils/common';

export default BaseActualFilterAmplitude.extend({
  r3: null,
  r4: null,
  opAmp: null,
  complexAlphaPlus: Complex.createComplex(0, 0),
  complexBetaPlus: Complex.createComplex(0, 0),
  complexRParallel: computed('r3', 'r4', 'opAmp', function () {
    var r3 = this.r3;
    var r4 = this.r4;
    var rOut = this.opAmp.rOut;
    var rParallel = CommonUtils.parallel(rOut, r3 + r4);
    var result = Complex.createComplex(rParallel, 0);
    return result;
  }),
  complexFF: Complex.createComplex(0, 0),
  complexAlphaMinus: Complex.createComplex(0, 0),
  complexBetaMinus: computed('r3', 'r4', 'sImaginary', function () {
    var sImaginary = this.sImaginary;

    var r3 = this.r3;
    var r4 = this.r4;

    var complexR3 = Complex.createComplex(r3, 0);
    var complexBetaDenom = Complex.createComplex(r3 + r4, r4 * r3 * 3e-12 * sImaginary);
    var result = complexR3.divide(complexBetaDenom);
    return result;
  }),
});
